import {ReactElement, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {IStore} from "@/redux/defaultStore";
import {useGetUserProfile} from "@/hooks/useGetUserProfile";
import {IoWalletSharp} from "react-icons/io5";
import {formatGoVIPNames} from "@/utils/formatGoVIPNames";
import {FaGear} from "react-icons/fa6";
import {BsPersonFill} from "react-icons/bs";
import {useNavigate, useLocation } from "react-router";
import EditProfilePictureModal from "@/components/modals/EditProfilePictureModal";
import {BiLogOut} from "react-icons/bi";
import ToggleSwitch from "./ToggleSwitch";
import {IoIosHelpCircle, IoMdPersonAdd} from "react-icons/io";
import {toggleChatOpen} from "@/redux/meta/metaActions";
import { useStreamerMode } from "@/hooks/useStreamerMode";
import { MdLiveTv } from "react-icons/md";
import useOnLogout from "@/hooks/useOnLogout";
import { InviteModal } from "./InviteModal";
import useThirwebWallet from "@/hooks/useThirwebWallet";

interface Props {
    renderProfilePicture: () => ReactElement;
    toggleWalletDropdown: () => void;
}

function DevourAccountDropdownMenuBody(props: Props): ReactElement {

    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);
    const {data: userProfileData} = useGetUserProfile(fullToken);
    const { hideCharacters } = useStreamerMode();
    const { streamerModeEnabled, setSteamerMode } = useStreamerMode();
    const [showInviteModal, setShowInviteModal] = useState(false);
    const history = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const {devourLogout} = useOnLogout();
    const { onOpenThirdwebWallet } = useThirwebWallet();

    const [
        count,
        setCount,
    ] = useState<number>(0);
    const [
        editProfileModal,
        setEditProfileModal,
    ] = useState<boolean>(false);

    function toggleEditProfileModal() {
        setEditProfileModal(!editProfileModal);
    }

    async function handleLogOut() {
        try {
            await devourLogout();
            // Check if current page requires authentication
            const authRequiredPages = ["/account", "/lootbox", "/collectibles", "/load-fuel", "/menu-orders"];
            const requiresAuth = authRequiredPages.some(page =>
                location.pathname.startsWith(page));

            if (requiresAuth) {
                history("/devourplay-discover");
            }
            // Otherwise stay on current page (games, play, devourplay-discover, etc)
        } catch (error) {
            console.error("Logout failed:", error);
            // On error, check same auth requirements
            const authRequiredPages = ["/account", "/lootbox", "/collectibles", "/load-fuel", "/menu-orders"];
            const requiresAuth = authRequiredPages.some(page =>
                location.pathname.startsWith(page));

            if (requiresAuth) {
                history("/devourplay-discover");
            }
        }
    }


    return (
        <>
            {fullToken &&
            <EditProfilePictureModal
                isOpen={editProfileModal}
                onClose={toggleEditProfileModal}
                onProfilePictureUpdate={() => setCount(count + 1)}
            />
            }

            <InviteModal isVisible={showInviteModal} onClose={() => setShowInviteModal(false)} />
            <div className="devour-top-nav_dropdown_account_profile-info">
                {props.renderProfilePicture()}
                <p>
                    {formatGoVIPNames(userProfileData?.user?.firstName, hideCharacters(userProfileData?.user?.lastName), userProfileData?.user?.nickname)}
                </p>
            </div>
            <hr/>
            <div className="devour-top-nav_dropdown_account_options">
                <div className="devour-top-nav_dropdown_account_options_row">
                    <MdLiveTv/>
                    <p>Streamer Mode</p>
                    <div className="devour-top-nav_dropdown_account_options_row_input">
                        <ToggleSwitch onChange={setSteamerMode} checked={streamerModeEnabled}/>
                    </div>

                </div>
            </div>
            <hr/>
            <div className="devour-top-nav_dropdown_account_options">
                <button
                    className="reset-button devour-top-nav_dropdown_account_options_row"
                    onClick={() => setShowInviteModal(true)}
                >
                    <IoMdPersonAdd/>
                    <p>Invite a Friend</p>
                </button>
                <button
                    className="reset-button devour-top-nav_dropdown_account_options_row"
                    onClick={onOpenThirdwebWallet}
                >
                    <IoWalletSharp/>
                    <p>Devour Wallet</p>
                </button>
                <div
                    className="devour-top-nav_dropdown_account_options_row"
                    onClick={() => history("/account")}
                >
                    <FaGear/>
                    <p>Account</p>
                </div>
                <button
                    className="reset-button devour-top-nav_dropdown_account_options_row"
                    onClick={toggleEditProfileModal}
                >
                    <BsPersonFill/>
                    <p>Edit Profile</p>
                </button>
                <button
                    className="reset-button devour-top-nav_dropdown_account_options_row"
                    onClick={props.toggleWalletDropdown}
                >
                    <IoWalletSharp/>
                    <p>Manage Wallets</p>
                </button>
                <button
                    className="reset-button devour-top-nav_dropdown_account_options_row"
                    onClick={() => dispatch(toggleChatOpen(true))}
                >
                    <IoIosHelpCircle/>
                    <p>Help Chat</p>
                </button>
            </div>
            <hr/>
            <div
                className="devour-top-nav_dropdown_account_options_row devour-top-nav_dropdown_account_options_logout"
                onClick={handleLogOut}
            >
                <BiLogOut/>
                <p>Log Out</p>
            </div>
        </>
    );
}

export default DevourAccountDropdownMenuBody;
